import { BookingStatus } from '@/entities/bookings/booking-status.enum';
import { InvoicingType } from '@/entities/bookings/invoicing-type.enum';
import type { Booking } from '@/entities/bookings/booking.entity';
import { isLongTermPricing } from '@/utils/pricing.utils';

const CONVERTIBLE_STATUSES: BookingStatus[] = [
  BookingStatus.OPEN,
  BookingStatus.CONFIRMED,
  BookingStatus.FLOATING,
  BookingStatus.HANDED_OVER,
];

const CUSTOMER_PAYS: InvoicingType[] = [
  InvoicingType.REGULAR,
  InvoicingType.COMMISSION,
  InvoicingType.COMPANY_REGULAR,
];

export function isEligibleForLongTermConversion(booking: Booking): boolean {
  return (
    !!booking.priceCalculation &&
    !isLongTermPricing(booking.priceCalculation) &&
    booking.hasPeriodicInvoicing &&
    CONVERTIBLE_STATUSES.includes(booking.status) &&
    CUSTOMER_PAYS.includes(booking.invoicingType) &&
    !booking.insuranceCase
  );
}
